import CircleDrawingTool from './circleDrawingTool/circleDrawingTool'
import DateRangeDrawingTool from './dateRangeDrawingTool/dateRangeDrawingTool'
import DisjointChannelDrawingTool from './disjointChannel/disjointChannel'
import DrawingBase from './drawing.base'
import { DrawingTypes } from './drawing.interface'
import EllipseDrawingTool from './ellipseDrawingTool/ellipseDrawingTool'
import FibonacciCirclesDrawingTool from './fibonacciCirclesDrawingTool/fibonacciCirclesDrawingTool'
import FibonacciDrawingTool from './fibonacciDrawingTool/fibonacciDrawingTool'
import FlatTopBottomDrawingTool from './flatTopBottomDrawingTool/flatTopBottomDrawingTool'
import IndicatorLineDrawingTool from './indicatorLineDrawingTool/indicatorLineDrawingTool'
import ForecastDrawingTool from './forecastDrawingTool/forecastDrawingTool'
import LineDrawingTool from './lineDrawingTool/lineDrawingTool'
import ParallelChannelDrawingTool from './parallelChannelDrawingTool/parallelChannelDrawingTool'
import PathDrawingTool from './pathDrawingTool/pathDrawingTool'
import PositionForecastDrawingTool from './positionForecastDrawingTool/positionForecastDrawingTool'
import PriceRangeDrawingTool from './priceRangeDrawingTool/priceRangeDrawingTool'
import RectangleDrawingTool from './rectangleDrawingTool/rectangeDrawingTool'
import RotatedRectangleDrawingTool from './rotatedRectangleTool/rotatedRectangleTool'
import TrendBasedFibonacciDrawingTool from './trendBasedFibonacciDrawingTool/trendBasedFibonacciDrawingTool'
import TriangleDrawingTool from './triangleDrawingTool/triangleDrawingTool'
import HorizontalLineTool from './horizontalLineTool/horizontalLineTool'
import GannFanDrawingTool from './gannFanDrawingTool/gannFanDrawingTool'
import XABCDPatternDrawingTool from './xabcdPatternTool/xabcdPatternTool'
import TrianglePatternDrawingTool from './trianglePatternTool/trianglePatternTool'
import ABCDPatternDrawingTool from './abcdPatternTool/abcdPatternTool'
import VerticalLineTool from './verticalLineTool/verticalLineTool'
import OiProfile from './oiProfile/oiProfile'
import ThreeDivesPatternTool from './3DivesPatternTool/3DivesPatternTool'
import CrossLineDrawingTool from './crossLineDrawingTool/crossLineDrawingTool'
import ElliottImpulseWaveTool from './elliottImpulseWave/elliottImpulseWave'
import HeadAndShoulderPatternTool from './headAndShoulderPatternTool/headAndShoulderPatternTool'
import TextTool from './textTool/textTool'
import PriceNoteTool from './priceNoteTool/priceNoteTool'
import ZoomInTool from './zoomInTool/zoomInTool'
import ContractSwitchTool from './contractSwitchTool/ContractSwitchTool'
import CorporateActionTool from './corporateActionTool/CorporateActionTool'
import OiHeatmapDrawing from './oiProfile/oiHeatmap'
import CompanyEventTool from './companyEventTool/CompanyEventTool'
import ReplaySelectionDrawing from './replaySelectionDrawing/replaySelectionDrawing'
import OrdersOnChartTool from './ordersOnChartTool/OrdersOnChartTool'
import OrderMarkersDrawing from './ordersOnChartTool/OrderMarkers'
import BrushDrawingTool from './brushTool/brushTool'
import FixedRangeVolumeProfile from './fixedRangeVolumeProfile/fixedRangeVolumeProfile'
import AnchoredVolumeProfile from './AnchoredVolumeProfile/anchoredVolumeProfile'
import NewsArticleTool from './newsArticleTool/NewsArticleTool'
import ChartAlertsOnChartTool from './chartAlertsOnChartTool/ChartAlertsOnChartTool'

export const HANDLER_STROKE_WIDTH = 2
export const HANDLER_RADIUS = 6
export const SNAP_THRESHOLD = 50

export const drawingClassMap: Record<DrawingTypes, typeof DrawingBase<any, any, any>> = {
    'oiHistorical': OiHeatmapDrawing,
    'oiHeatmap': OiHeatmapDrawing,
    'simpleIndicatorLine': IndicatorLineDrawingTool,
    'infoIndicatorLine': IndicatorLineDrawingTool,
    'oiProfile': OiProfile,
    'trendLine': LineDrawingTool,
    'ray': LineDrawingTool,
    'arrow': LineDrawingTool,
    'extendedLine': LineDrawingTool,
    'trendAngle': LineDrawingTool,
    'infoLine': LineDrawingTool,
    'simpleLine': LineDrawingTool,
    'parallelChannel': ParallelChannelDrawingTool,
    'flatTopBottom': FlatTopBottomDrawingTool,
    'disjointChannel': DisjointChannelDrawingTool,
    'rectangle': RectangleDrawingTool,
    'ellipse': EllipseDrawingTool,
    'triangle': TriangleDrawingTool,
    'circle': CircleDrawingTool,
    'path': PathDrawingTool,
    'polyLine': PathDrawingTool,
    'rotatedRectangle': RotatedRectangleDrawingTool,
    'fibonacci': FibonacciDrawingTool,
    'trendBasedFibonacci': TrendBasedFibonacciDrawingTool,
    'positionForecast': PositionForecastDrawingTool,
    'dateRange': DateRangeDrawingTool,
    'priceRange': PriceRangeDrawingTool,
    'forecast': ForecastDrawingTool,
    'fibonacciCircles': FibonacciCirclesDrawingTool,
    'horizontalLine': HorizontalLineTool,
    'horizontalRay': HorizontalLineTool,
    'gannFan': GannFanDrawingTool,
    'xabcdPattern': XABCDPatternDrawingTool,
    'abcdPattern': ABCDPatternDrawingTool,
    'trianglePattern': TrianglePatternDrawingTool,
    'verticalLine': VerticalLineTool,
    'crossLine': CrossLineDrawingTool,
    '3DivesPattern': ThreeDivesPatternTool,
    'elliottImpulseWave': ElliottImpulseWaveTool,
    'headAndShoulderPattern': HeadAndShoulderPatternTool,
    'text': TextTool,
    'anchoredText': TextTool,
    'priceNote': PriceNoteTool,
    'zoomIn': ZoomInTool,
    'contractSwitch': ContractSwitchTool,
    'corporateAction': CorporateActionTool,
    'companyEvent': CompanyEventTool,
    'newsArticle': NewsArticleTool,
    'replaySelection': ReplaySelectionDrawing,
    'brush': BrushDrawingTool,
    'fixedRangeVolumeProfile': FixedRangeVolumeProfile,
    'anchoredVolumeProfile': AnchoredVolumeProfile,
    'chartOrdersActions': OrdersOnChartTool,
    'orderMarkers': OrderMarkersDrawing,
    'chartAlertsOnChart': ChartAlertsOnChartTool
}